<template>
  <div class="pcSetting">
    <el-button
      type="primary"
      size="small"
      style="position: absolute; right: 10px; top: 0"
      @click="saveSchoolPage"
      v-auth="'onlineSchool_/schoolPage/updateHomeSchoolPageByTemplateId'"
      >保存</el-button
    >

    <div class="pcSettingMain">
      <!-- <div class="pcLeft">网校模板</div> -->

      <div class="pcCenter">
        <div class="pageContainer" id="pcCenterMain">
          <div v-for="(pageItem, pageIndex) in homePageList" :key="pageItem.id">
            <div
              :class="pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'"
              @click="activeModule(pageIndex)"
              v-if="pageItem.type == 1"
              :key="pageItem.id"
            >
              <template
                v-if="
                  pageItem.schoolPageItemList &&
                  pageItem.schoolPageItemList.length > 0
                "
              >
                <carousel
                  :list="pageItem.schoolPageItemList"
                  :editForm="pageItem.template"
                ></carousel>
              </template>
              <template v-else>
                <div class="emptyDiv">轮播图</div>
              </template>
            </div>
            <div
              class="mainContent"
              v-if="pageItem.type == 2"
              :key="pageItem.id"
            >
              <div
                :class="
                  pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                "
                @click="activeModule(pageIndex)"
              >
                <template
                  v-if="
                    pageItem.schoolPageItemList &&
                    pageItem.schoolPageItemList.length > 0
                  "
                >
                  <div class="moudleTitle">{{ pageItem.title }}</div>
                  <div
                    class="moudleGoodsMain"
                    :class="
                      pageItem.template &&
                      pageItem.template.objectType == '分页'
                        ? ''
                        : 'flex'
                    "
                  >
                    <div
                      v-for="item in pageItem.schoolPageItemList"
                      :key="item.id"
                    >
                      <muban-template
                        :attributeObj="item"
                        :mubanWidth="pageItem.mubanWidth"
                        :dynamicObj="item.dynamicObj"
                      ></muban-template>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="emptyDiv">广告模板</div>
                </template>
              </div>
            </div>
            <div
              :class="pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'"
              @click="activeModule(pageIndex)"
              v-if="pageItem.type == 3"
              :key="pageItem.id"
            >
              <component :is="pageItem.title" v-if="pageItem.title"></component>
              <div class="emptyDiv" v-else>自定义组件</div>
            </div>
            <!-- 广告 -->
            <div
              class="mainContent"
              v-if="pageItem.type == 4"
              :key="pageItem.id"
            >
              <div
                :class="
                  pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                "
                @click="activeModule(pageIndex)"
              >
                <div class="moudleTitle">{{ pageItem.title }}</div>
                <div class="moudleGoodsMain flex">
                  <div
                    v-for="item in pageItem.schoolPageItemList"
                    :key="item.id"
                  >
                    <muban-template
                      :attributeObj="{ schoolPageInfo: item }"
                      :mubanWidth="pageItem.mubanWidth"
                      :dynamicObj="item.dynamicObj"
                    ></muban-template>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="moduleMain"
              :class="[{ active: pageItem.moduleHover }]"
              :style="
                pageItem.schoolPageItemList[0] &&
                pageItem.schoolPageItemList[0].dynamicObj
                  ? pageItem.schoolPageItemList[0].dynamicObj.style
                  : ''
              "
              @click="activeModule(pageIndex)"
              v-if="pageItem.type == 5"
              :key="pageItem.id"
            >
              <template
                v-if="
                  pageItem.schoolPageItemList &&
                  pageItem.schoolPageItemList.length > 0
                "
              >
                <div class="moudleGoodsMain">
                  <div
                    v-for="item in pageItem.schoolPageItemList"
                    :key="item.id"
                  >
                    <muban-template
                      :attributeObj="item"
                      :mubanWidth="pageItem.mubanWidth"
                      :dynamicObj="item.dynamicObj"
                    ></muban-template>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="emptyDiv">悬浮窗</div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="pcRight">
        <div class="operation">
          <div v-if="!activeType" class="operation-1">
            <div class="operation-1-text">请点击选中左侧模块区域进行编辑</div>
          </div>

          <div v-if="homePageList.length > 0">
            <div v-if="activeType == 1">
              <div class="operation-name">轮播图</div>
              <div class="operation-1">
                <div class="operation-1-text">添加内容</div>
                <div class="operation-1-text1">
                  最多添加12个轮播图，拖动选中的轮播图可对其排序，建议尺寸750*260像素
                </div>
              </div>
              <div
                class="operation-2"
                v-if="
                  homePageList[activeIndex] &&
                  homePageList[activeIndex].schoolPageItemList
                "
              >
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="operation-2-list"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="item.id"
                  >
                    <div class="list-img">
                      <el-upload
                        class="crm-upload"
                        :action="fileObj.url"
                        :before-upload="lbtbeforeUpload"
                        :on-success="lbtSuccessUpdate"
                        :headers="reqData"
                        :show-file-list="false"
                      >
                        <img
                          class="list-img"
                          :src="item.picture"
                          @click="updateImg(index)"
                          alt
                        />
                        <div class="list-img-uptext" @click="updateImg(index)">
                          修改
                        </div>
                      </el-upload>
                    </div>
                    <div class="list-msg">
                      <div class="list-msg-item">
                        <span style="width: 50px">标题</span>
                        <el-input
                          size="mini"
                          style="width: 200px"
                          placeholder="选填"
                          v-model="item.title"
                          clearable
                        ></el-input>
                      </div>

                      <div class="list-msg-item">
                        <span style="width: 50px">链接</span>
                        <el-input
                          style="width: 140px"
                          @input="changeInput(index)"
                          size="mini"
                          v-if="item.type == 2"
                          v-model="item.title"
                          clearable
                        ></el-input>
                        <el-input
                          style="width: 140px"
                          size="mini"
                          @input="changeInput(index)"
                          v-else-if="item.linkUrl"
                          v-model="item.linkUrl"
                          clearable
                        ></el-input>
                        <el-dropdown trigger="click" @command="handleCommand">
                          <span
                            class="el-dropdown-link"
                            style="
                              color: rgb(77, 148, 255);
                              cursor: pointer;
                              margin-left: 10px;
                            "
                          >
                            {{
                              item.linkUrl || item.type == 2
                                ? "修改"
                                : "选择跳转到的页面"
                            }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item :command="1+'-'+index">页面路径</el-dropdown-item> -->
                            <el-dropdown-item :command="2 + '-' + index"
                              >广告模板</el-dropdown-item
                            >
                            <el-dropdown-item :command="4 + '-' + index"
                              >外部链接</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <i
                      class="el-icon-delete operation-delete"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                  <!-- </transition-group> -->
                </draggable>
              </div>
              <div class="operation-2-button">
                <el-upload
                  style="width: 100%"
                  class="crm-upload"
                  :action="fileObj.url"
                  :before-upload="lbtbeforeUpload"
                  :on-success="lbtSuccess"
                  :headers="reqData"
                  multiple
                  :show-file-list="false"
                >
                  <el-button icon="el-icon-plus" style="width: 380px"
                    >添加轮播图</el-button
                  >
                </el-upload>
              </div>
            </div>

            <div v-if="activeType == 2">
              <div class="operation-name">模板</div>

              <div class="line"></div>
              <div
                class="operation-2"
                v-if="
                  this.homePageList[this.activeIndex].template &&
                  this.homePageList[this.activeIndex].template.objectType !=
                    '分页' &&
                  this.homePageList[this.activeIndex].template.objectType !=
                    '组合'
                "
              >
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="label-show chunk"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="index"
                    @click="openaddFormVisible(1, index)"
                  >
                    <span style="width: 50px">{{ activeObjectType }}:</span>
                    <span style="color: #4d94ff; width: 260px">{{
                      item.title
                    }}</span>
                    <i
                      class="el-icon-delete chunk-delete"
                      v-if="homePageList[activeIndex].sortType == 3"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                </draggable>

                <div
                  class="operation-2-button"
                  v-if="homePageList[activeIndex].sortType == 3"
                >
                  <el-button icon="el-icon-plus" style="width: 100%"
                    >添加课程</el-button
                  >
                </div>
              </div>
            </div>

            <div v-if="activeType == 3">
              <div class="operation-name">自定义</div>
            </div>
            <!-- 广告 -->
            <div v-if="activeType == 4">
              <div class="operation-name">广告</div>

              <div class="operation-1">
                <div class="operation-1-text">
                  修改内容:推荐图片尺寸{{ imageSize.width }}*{{
                    imageSize.height
                  }}
                </div>
                <div class="operation-1-text1">
                  <!-- 最多添加12个轮播图，拖动选中的轮播图可对其排序，建议尺寸750*260像素 -->
                </div>
              </div>

              <div
                class="operation-2"
                v-if="
                  homePageList[activeIndex] &&
                  homePageList[activeIndex].schoolPageItemList
                "
              >
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="operation-2-list"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="item.id"
                  >
                    <div class="list-img">
                      <el-upload
                        class="crm-upload"
                        :action="fileObj.url"
                        :before-upload="lbtbeforeUpload"
                        :on-success="lbtSuccessUpdate"
                        :headers="reqData"
                        :show-file-list="false"
                      >
                        <img
                          class="list-img"
                          :src="item.picture"
                          @click="updateImg(index)"
                          alt
                        />
                        <div class="list-img-uptext" @click="updateImg(index)">
                          修改
                        </div>
                      </el-upload>
                    </div>
                    <div class="list-msg">
                      <div class="list-msg-item">
                        <span style="width: 50px">链接</span>
                        <el-input
                          style="width: 140px"
                          @input="changeInput(index)"
                          size="mini"
                          v-if="item.type == 2"
                          v-model="item.title"
                          clearable
                        ></el-input>
                        <el-input
                          style="width: 140px"
                          size="mini"
                          @input="changeInput(index)"
                          v-else-if="item.linkUrl"
                          v-model="item.linkUrl"
                          clearable
                        ></el-input>
                        <el-dropdown trigger="click" @command="handleCommand">
                          <span
                            class="el-dropdown-link"
                            style="
                              color: rgb(77, 148, 255);
                              cursor: pointer;
                              margin-left: 10px;
                            "
                          >
                            {{
                              item.linkUrl || item.type == 2
                                ? "修改"
                                : "选择跳转到的页面"
                            }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="4 + '-' + index"
                              >外部链接</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
            <!-- 广告 -->
            <div v-if="activeType == 5">
              <div class="operation-name">悬浮窗</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="自定义链接"
      :visible.sync="addFormVisible3"
      width="40%"
      left
    >
      <el-form label-width="80px">
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="链接地址">
              <el-input style="width: 100%" v-model="linkUrl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog3">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="'添加'"
      :visible.sync="addFormVisible"
      width="60%"
      left
      :close-on-click-modal="false"
    >
      <el-form :label-width="formLabelWidth">
        <div v-if="activeObjectType == '商品'">
          <el-row :span="24">
            <el-col :sm="5" :md="5" :lg="5">
              <el-form-item label="所属分类" label-width="80px" prop="pid">
                <el-cascader
                  v-model="searchForm.subjectIds"
                  :show-all-levels="false"
                  ref="tree"
                  collapse-tags
                  :options="subjectTreeList"
                  :props="subjectTreeProps"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :sm="5" :md="5" :lg="5">
              <el-form-item
                label="是否限购"
                label-width="80px"
                prop="flashSaleType"
              >
                <el-select
                  v-model="searchForm.flashSaleType"
                  placeholder="请选择"
                  clearable
                >
                  <el-option value="">全部</el-option>
                  <el-option :value="1">是</el-option>
                  <el-option :value="-1">否</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item label="商品名称">
                <el-input v-model="searchForm.name"></el-input>
              </el-form-item>
            </el-col>

            <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                :data="tableList"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                @current-change="selectionChange"
                border
                v-loading="loading1"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
              >
                <el-table-column prop="name" show-overflow-tooltip label="商品">
                  <template slot-scope="row">
                    <el-row>
                      <el-col :span="8">
                        <span>
                          <img
                            style="margin-right: 10px"
                            width="100%"
                            height="44px"
                            :src="
                              row.row.logo
                                ? row.row.logo
                                : '../../../static/image/noImg.png'
                            "
                          />
                        </span>
                      </el-col>
                      <el-col :span="16">
                        <span
                          style="color: rgb(77, 148, 255); margin-left: 10px"
                          >{{ row.row.name }}</span
                        >
                        <span style="display: block; margin-left: 10px">
                          <span style="color: red">￥{{ row.row.price }}</span>
                          <span
                            style="
                              text-decoration: line-through;
                              color: rgb(162, 170, 188);
                            "
                            >￥{{ row.row.originalPrice }}</span
                          >
                        </span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="200"
                  prop="agentPrice"
                  label="售价"
                >
                  <template slot-scope="row">
                    <span style="display: block">
                      <span style="color: red">￥{{ row.row.price }}</span>
                      <span
                        style="
                          text-decoration: line-through;
                          color: rgb(162, 170, 188);
                        "
                        >￥{{ row.row.originalPrice }}</span
                      >
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="validDay"
                  width="100"
                  label="有效期"
                >
                  <template slot-scope="row">{{
                    row.row.validDay ? row.row.validDay + "天" : "不限"
                  }}</template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="200"
                  prop="subjectCourseName"
                  label="所属科目"
                ></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
        <div v-else-if="activeObjectType == '政策'">
          <!-- <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                :data="tableList"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                @current-change="selectionChange"
                border
                v-loading="loading1"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
              >
                <el-table-column prop="poster" label="图片" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.poster
                          ? row.row.poster
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="city" label="城市" width="120"></el-table-column>
                <el-table-column prop="title" label="标题" width="250"></el-table-column>
                <el-table-column
                  prop="content"
                  label="内容"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row> -->
          <el-form
            ref="addForm"
            :model="addForm"
            :label-width="formLabelWidth"
            :rules="addFormRules"
          >
            <el-row :gutter="20">
              <el-col :span="14">
                <el-form-item label="标题" prop="title">
                  <el-input
                    style="width: 100%"
                    v-model="addForm.title"
                    placeholder="请输入标题"
                    auto-complete="off"
                    maxlength="255"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-form-item label="导语" prop="introduction">
                  <el-input
                    style="width: 100%"
                    v-model="addForm.introduction"
                    placeholder="请输入导语"
                    auto-complete="off"
                    maxlength="255"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="内容" prop="content">
                  <div style="background: #fff" v-if="showUe">
                    <UE :value="ueTtext" ref="myQuillEditorTitle"></UE>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div v-else-if="activeObjectType == '资讯'">
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                :data="tableList"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                @current-change="selectionChange"
                border
                v-loading="loading1"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
              >
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="poster" label="主海报" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.poster
                          ? row.row.poster
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="poster" label="主海报" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.poster
                          ? row.row.poster
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="avatar" label="头像" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.avatar
                          ? row.row.avatar
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  label="内容"
                  width="300px"
                  show-overflow-tooltip
                >
                  <template slot-scope="row">
                    <div class="news-content" v-html="row.row.content"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="summary" label="简介"></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
        <div v-else-if="activeObjectType == '机构'">
          <el-row :span="24">
            <el-col :sm="9" :md="9" :lg="9">
              <el-form-item label="所属分类" label-width="80px" prop="pid">
                <el-cascader
                  v-model="searchForm.subjectIds"
                  :show-all-levels="false"
                  ref="tree"
                  collapse-tags
                  :options="schoolTreeList"
                  :props="subjectTreeProps"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                :data="tableList"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                @current-change="selectionChange"
                border
                v-loading="loading1"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
              >
                <el-table-column prop="img" label="图片" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.img
                          ? row.row.img
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="dictionaryName"
                  label="城市"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="标题"
                  width="250"
                ></el-table-column>
                <el-table-column
                  prop="rate"
                  label="评分"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imageTemplate from "./diyTemplate/imageTemplate";
import cityTemplate from "./diyTemplate/cityTemplate";
import limitPurchase from "./diyTemplate/limitPurchase";
import moreCityTemplate from "./diyTemplate/moreCityTemplate";
import popularRecommendation from './diyTemplate/popularRecommendation'
import liveDisplay from './diyTemplate/liveDisplay'
import teacher from './diyTemplate/teacher'
import Header from "./diyTemplate/Header";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import mubanTemplate from "./template/mubanTemplate.vue";
import carousel from "./template/carousel";
import UE from "../conmom/CKEditorInformation.vue";
export default {
  components: {
    draggable,
    mubanTemplate,
    carousel,
    Header,
    cityTemplate,
    limitPurchase,
    moreCityTemplate,
    imageTemplate,
    UE,
    popularRecommendation,
    liveDisplay,
    teacher
  },
  props: {
    schoolMenuId: String,
    schoolPageMenuId: String,
  },
  data() {
    return {
      imageSize: {},
      schoolTreeList: [],
      activeObjectType: "",
      addFormVisibleSpkc: false,
      linkUrl: "",
      addFormVisible3: false,
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: [],
      },

      addForm: {
        title: "",
        introduction: "",
        content: "",
      },
      addFormRules: {
        // ids: [{
        //     required: true,
        //     message: '请输入城市',
        //     trigger: 'blur'
        // }],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
        // poster: [
        //   {
        //     required: true,
        //     message: "上传海报",
        //     trigger: "blur",
        //   },
        // ],
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "标题长度在1到20个字",
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/policy/upload`,
      showUe: false,
      ueTtext: "",

      pageMenuList: [],
      isShowObjectId: false,
      choosedTemplate: "",
      state: 1,
      homePageList: [],
      // activeModuleId:'',
      activeIndex: "",
      activeType: "",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      itemIndex: "",
      tableList: [],
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      arrsSelect: [],
      loading1: false,
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
        multiple: true,
      },
      addFormVisible: false,
      checkList: [],
      linkUrl: "",
      formLabelWidth: "80px",
      addFormVisibleSpkc: false,
      addGoodsFormType: 1,
      addopenaddInformationFormVisible: false,
      informationSearchForm: {
        title: "",
      },
      informationPage: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      informationList: [],
      informationCheckList: [],
    };
  },
  watch: {
    addFormVisible(val) {
      if (!val) {
        this.searchForm.subjectIds = [];
        this.searchForm.name = "";
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.ueTtext = "";
        this.showUe = false;
      } else {
        this.showUe = true;
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.showUe = false;
        this.ueTtext = "";
      } else {
        this.ueTtext = "";
      }
    },
  },
  created() {
    this.getSchoolPageMenuListByUrl();
    this.getSubjectTreeList();
  },
  methods: {
    // 轮播图------------------------------------------------------------
    lbtbeforeUpload(file) {
      this.loading = true;
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        this.loading = false;
      }
      return isJPG && isLt2M;
    },
    lbtSuccessUpdate(res, file, fileList, val) {
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].picture = res.data;
      this.itemIndex = "";
    },
    lbtSuccess(res, file, fileList, val) {
      if (!this.homePageList[this.activeIndex].schoolPageItemList) {
        this.homePageList[this.activeIndex].schoolPageItemList = [];
      }
      this.homePageList[this.activeIndex].schoolPageItemList.push({
        picture: res.data,
        title: "",
        type: "1",
        sort: this.homePageList[this.activeIndex].schoolPageItemList.length,
      });
    },
    updateImg(index) {
      this.itemIndex = index;
    },
    deleteItem(index) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.homePageList[this.activeIndex].schoolPageItemList.splice(
            index,
            1
          );
        })
        .catch(() => {});
    },
    changeInput(index) {
      this.homePageList[this.activeIndex].schoolPageItemList[index].linkUrl =
        "";
      this.homePageList[this.activeIndex].schoolPageItemList[index].title = "";
      this.homePageList[this.activeIndex].schoolPageItemList[index].type = "";
      this.$forceUpdate();
    },
    handleCommand(command) {
      let arr = command.split("-");
      let type = arr[0];
      this.itemIndex = arr[1];
      if (type == 1) {
      } else if (type == 2) {
        this.openaddFormVisible(1);
      } else if (type == 4) {
        this.addFormVisible3 = true;
      }
    },
    closeDialog3() {
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].linkUrl = this.linkUrl;
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].type = 1;
      this.linkUrl = "";
      this.addFormVisible3 = false;
    },
    openaddFormVisible(type, index) {
      this.addForm.relationId =
        this.homePageList[this.activeIndex].schoolPageItemList[
          index
        ].relationId;
      this.ueTtext = this.homePageList[this.activeIndex].schoolPageItemList[
        index
      ].schoolPageInfo
        ? this.homePageList[this.activeIndex].schoolPageItemList[index]
            .schoolPageInfo.content
        : "";
      this.addForm = this.homePageList[this.activeIndex].schoolPageItemList[
        index
      ].schoolPageInfo
        ? this.homePageList[this.activeIndex].schoolPageItemList[index]
            .schoolPageInfo
        : {};
      this.itemIndex = index;
      if (type == 1) {
        this.addGoodsFormType = 1;
        this.addFormVisible = true;
      } else if (type == 2) {
        this.addGoodsFormType = 2;
        this.addFormVisible = true;
      }
      this.getList();
    },
    getSubjectTreeList() {
      let arr = [];
      /*  this.api.getSubjectCourseAllTree({}).then((_res) => {
        this.subjectTreeList = this.changeDisable(_res.data);
      }); */
      this.api.campus
        .getPermissionSubjectTree()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;

                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }

          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeDisable(arr) {
      if (arr && arr.length > 0) {
        arr.forEach((item) => {
          item.disabled = false;
          this.changeDisable(item.children);
        });
        return arr;
      } else {
        return [];
      }
    },
    getList() {
      this.loading1 = true;
      let arr = [];
      console.log("sub", this.searchForm.subjectIds);
      if (this.searchForm.subjectIds.length > 0) {
        this.searchForm.subjectIds.forEach((item) => {
          // arr.push(item.reverse[0]);
          arr.push(item[1]);
        });
      }
      let obj = {
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        sortName: this.page.sortName,
        sortOrder: this.page.sortOrder,
        agentId: this.loginData.agentId,
        flashSaleType: this.searchForm.flashSaleType,
        name: this.searchForm.name,
        subjectIds: arr,
      };
      let requestUrl = "pageList";
      if (this.activeObjectType == "政策") {
        requestUrl = "pageListPolicy";
      } else if (this.activeObjectType == "资讯") {
        requestUrl = "pageListInformation";
      } else if (this.activeObjectType == "机构") {
        requestUrl = "pageListCampus";
      }

      this.api.goodsInfo[requestUrl](obj)
        .then((result) => {
          this.loading1 = false;
          this.tableList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
        })

        .catch((error) => {
          console.log(error);
        });
    },
    closeDialog() {
      // if (this.activeIndex === 8) {
      //   this.addPolicy();
      // } else {
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].relationId = this.checkList.id;
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].title =
        this.activeObjectType != "商品" && this.activeObjectType != "机构"
          ? this.checkList.title
          : this.checkList.name;
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].schoolPageInfo = {
        ...this.checkList,
      };
      // }
      if (this.activeObjectType === "政策") {
        const isClose = this.addPolicy();
        if (isClose) {
          this.itemIndex = "";
          this.addFormVisible = false;
          this.addFormVisibleSpkc = false;
        }
        return;
      }
      this.itemIndex = "";
      this.addFormVisible = false;
      this.addFormVisibleSpkc = false;
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    selectionChange(val) {
      this.checkList = val;
    },
    //------------------------------------------------------------轮播图
    // 自定义组件------------------------------------------------------------
    objectAssign(obj) {
      let jsonObj = JSON.parse(obj.styleJson);
      return Object.assign({}, obj, jsonObj);
    },
    // ------------------------------------------------------------自定义组件
    getSchoolPageMenuListByUrl() {
      this.getHomePageListByTemplateId();
    },
    activeModule(pageIndex) {
      for (let item of this.homePageList) {
        this.$set(item, "moduleHover", false);
      }
      let homePageListItem = this.homePageList[pageIndex];
      this.activeIndex = pageIndex;
      this.activeType = homePageListItem.type;
      if (this.homePageList[pageIndex].type == 2) {
        if (this.homePageList[pageIndex].schoolPageItemList.length != 0) {
          this.homePageList[pageIndex].schoolPageItemList.forEach((item) => {
            if (item.type == 2) {
              this.activeObjectType = "商品";
            } else if (item.type == 3) {
              this.activeObjectType = "资讯";
            } else if (item.type == 4) {
              this.activeObjectType = "政策";
            } else if ((item.type = 6)) {
              this.activeObjectType == "机构";
            }
          });
        }
      } else if (this.homePageList[pageIndex].type == 4) {
        let obj =
          this.homePageList[pageIndex].template.htmlStyleList[0].styleJson;
        obj = JSON.parse(obj);
        this.imageSize = {
          width: obj.width,
          height: obj.height,
        };
      }
      this.$set(this.homePageList[pageIndex], "moduleHover", true);
    },
    getHomePageListByTemplateId() {
      this.api.schoolPage
        .getHomePageListByTemplateId({
          schoolPageMenuId: this.schoolPageMenuId,
        })
        .then((result) => {
          this.loading = false;
          if (result.success) {
            result.data.forEach((item) => {
              if (item.type == 2 || item.type == 5 || item.type == 4) {
                item.schoolPageItemList.forEach((_item) => {
                  _item.dynamicObj = item.template;
                });
                item.mubanWidth = 1200 / item.colAmount;
              }
            });

            this.$set(this, "homePageList", result.data);
            this.homePageList = result.data;
            this.activeIndex = 0;
          } else {
            this.homePageList = [];
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    datadragEnd(evt) {
      evt.preventDefault();
    },
    datadragEndContent(evt) {
      this.activeModule(evt.newIndex);
      evt.preventDefault();
    },
    saveSchoolPage() {
      this.homePageList.forEach((item) => {
        item.schoolPageMenuId = this.schoolPageMenuId;
      });
      this.api.schoolPage
        .updateHomeSchoolPageByTemplateId({
          id: this.schoolMenuId,
          schoolPageList: this.homePageList,
        })
        .then((result) => {
          if (result.success) {
            this.activeIndex = "";
            this.activeType = "";
            this.getHomePageListByTemplateId();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // ===============================================
    // 添加政策
    addPolicy() {
      const itemIndex = this.itemIndex;
      this.addForm.content = this.$refs.myQuillEditorTitle._data.content;
      console.log(this.addForm.relationId);
      if (this.addForm.relationId) {
        // 修改
        this.homePageList[this.activeIndex].schoolPageItemList[
          this.itemIndex
        ].title = title;
        this.homePageList[this.activeIndex].schoolPageItemList[
          this.itemIndex
        ].schoolPageInfo = { title, content, introduction };
      } else {
        const { title, content, introduction } = this.addForm;
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.homePageList[this.activeIndex].schoolPageItemList[
              this.itemIndex
            ].title = title;
            this.homePageList[this.activeIndex].schoolPageItemList[
              this.itemIndex
            ].schoolPageInfo = { title, content, introduction };

            this.api.policy
              .addPolicy({ title, content, introduction })
              .then((result) => {
                this.homePageList[this.activeIndex].schoolPageItemList[
                  itemIndex
                ].relationId = result.data;
                this.addFormVisible = false;
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
      }
    },

    handleAvatarSuccess(res, file) {
      this.addForm.poster = res.data.split("?")[0];
    },
    editHandleAvatarSuccess(res, file) {
      this.editForm.poster = res.data.split("?")[0];
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },

  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },
};
</script>
<style lang="less" scoped>
.pcSetting {
  .news-content {
    height: 50px;
    img {
      display: none;
    }
  }
  .pcSettingMain {
    display: flex;
    min-height: 700px;
    justify-content: space-between;
    // overflow-x: scroll;
  }
  .pcLeft {
    width: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #eee;
  }
  .pcLeftItem {
    width: 60px;
    height: 60px;
    margin-top: 15px;
    padding: 2px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .pcLeftItem:hover {
    background: #266ef6;
    color: #fff;
  }
  .pcRight {
    width: 400px;
    border-left: 1px solid #eee;
    padding: 10px;
    margin-top: 30px;
  }
  .pcRight-title {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }
  .pcCenter {
    overflow-x: scroll;
    background: #f6f7f9;
    position: relative;
    // width: 910px;
  }

  // 中间区域css
  .pageContainer {
    padding-bottom: 20px;
    color: #455a64;
    height: 700px;
    width: 1500px;
  }
  .mainContent {
    width: 1204px;
    margin: 0 auto;
  }
  .el-menu {
    border-bottom: none !important;
  }
  .el-menu-item {
    padding: 0;
    margin: 0 20px !important;
    font-size: 16px;
  }
  .flex {
    display: -webkit-flex; /* Safari */
    display: flex;
  }
  .font1Line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .font2Line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .font6Line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }
  .moduleMain {
    margin-top: 20px;
    cursor: pointer;
    position: relative;
    border: 2px solid #f6f7f9;
  }
  .moduleMain.active {
    border: 2px solid #266ef6;
  }
  .moduleMain:hover {
    border: 2px dashed #266ef6;
  }
  .moudleTitle {
    font-size: 24px;
    padding: 10px 0;
  }
  .moudleGoodsMain {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .moudleNewsMain {
    width: 700px;
  }
  .moudleNewsMain img {
    width: 350px;
    height: 200px;
    border-radius: 5px;
  }
  .moudleGoodsItem {
    width: 166px;
    height: 180px;
    margin-top: 10px;
    border-radius: 5px;
    background-color: #fff;
    margin-left: 5px;
    // cursor: pointer;
  }
  .moudleGoodsItem img {
    height: 100px;
    width: 166px;
    border-radius: 5px;
  }
  .moudleGoodsName {
    padding: 5px 10px 0 10px;
    // font-size: 16px;
    height: 35px;
  }
  .moudleGoodsEnd {
    justify-content: space-between;
    padding: 5px 10px 0 10px;
    align-items: center;
  }
  .moudleGoodsSell {
    color: #a2aabc;
    font-size: 12px;
  }
  .moudleGoodsPrice {
    color: #fc5e5e;
  }
  .moudleGoodsPrice span {
    font-size: 24px;
  }
  .newsTitleMain {
    margin-left: 40px;
    font-size: 16px;
    line-height: 20px;
  }
  .parentLinkMain {
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
  }
  .parentLinkItem {
    flex-wrap: wrap;
  }
  .parentLinkItem div {
    margin: 5px 5px 0 0;
    color: #a2aabc;
    font-size: 12px;
  }
  //结束
  .icon-shanchu {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #79797a;
    color: #fff;
    padding: 4px;
    z-index: 999;
  }
  .pcRightTips {
    color: #a2aabc;
    font-size: 13px;
  }
  .lunboItem {
    width: 420px;
    height: 80px;
  }
  .operation {
    // position: fixed;
    // top: 123px;
    // right: 20px;
    width: 380px;
    height: calc(100% - 0px);
    // background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(238, 238, 238, 1);
    font-family: "微软雅黑";
    font-weight: 400;
    font-style: normal;
    background-color: #fafafa;
    .operation-2 {
      padding: 20px;
      .operation-2-button {
      }
      .operation-2-list:hover {
        .operation-delete {
          display: inline-block;
        }
      }
      .operation-2-list {
        position: relative;
        margin-bottom: 10px;
        background-color: rgba(255, 255, 255, 1);
        border-width: 1px;
        border-style: solid;
        padding: 10px;
        border-color: rgba(238, 238, 238, 1);
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .operation-delete {
          position: absolute;
          bottom: 6px;
          right: 10px;
          z-index: 100;
          cursor: pointer;
          font-size: 14px;
          color: rgba(255, 85, 85, 1);
          display: none;
        }
        .list-msg {
          margin-left: 10px;
          .list-msg-item {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
            }
          }
        }
        .list-img {
          width: 60px;
          height: 60px;
          z-index: 2000;
          position: relative;
          .list-img-uptext {
            z-index: 2000;
            width: 60px;
            height: 20px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: #333;
            opacity: 0.6;
            color: #fff;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }
        }
      }
    }
    .operation-1 {
      background-color: rgba(255, 255, 255, 1);
      padding: 20px;
      .operation-1-text {
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        color: #455a64;
        line-height: 14px;
      }
      .operation-1-text1 {
        padding-top: 10px;
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        color: #a2aabc;
        line-height: 16px;
      }
    }
    .operation-name {
      background-color: rgba(255, 255, 255, 1);
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #455a64;
      text-align: left;
      line-height: 60px;
      padding: 0 0 0 20px;
    }
  }
  .label-show {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .chunk {
    height: 40px;
    line-height: 40px;
    padding: 0px 0px 0px 10px;
    background-color: rgba(255, 255, 255, 1);
    cursor: pointer;
    .chunk-delete {
      font-size: 14px;
      color: rgba(255, 85, 85, 1);
      display: none;
    }
  }
  .chunk:hover {
    .chunk-delete {
      display: inline-block;
    }
  }
  .emptyDiv {
    border: 2px solid #a2aabc;
    color: #a2aabc;
    font-size: 30px;
    text-align: center;
    line-height: 400px;
  }
}
.avatar {
  width: 148px;
  height: 148px;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/pcSetting.vue